import React from "react";
import { Flex, Heading, IconBunningsWarehouse, IconCatch, IconKmart, IconTarget, } from "@catchoftheday/cg-components";
export const Divisions = () => {
    return (<Flex alignItems="center" flexWrap="wrap" pt={{
            xs: 8,
            md: 10,
        }} pb={{
            xs: 10,
            md: 20,
        }}>
      <Heading.h3 fontWeight="medium" color="onePass.textPrimary" mt={0} mb={{
            xs: 5,
            md: 0,
        }} width={{
            xs: "100%",
            md: "45%",
        }} textAlign={{
            xs: "center",
            md: "left",
        }}>
        Bringing together Australia&apos;s favourite brands
      </Heading.h3>
      <Flex justifyContent="space-between" alignItems="center" flexWrap="nowrap" width={{
            xs: "100%",
            md: "55%",
        }} mr={{
            xs: "auto",
            md: 0,
        }} ml="auto" maxWidth={{
            xs: "360px",
            md: "600px",
        }}>
        <IconCatch width={{
            xs: "60px",
            md: "80px",
        }} height="auto"/>
        <IconKmart width={{
            xs: "60px",
            md: "90px",
        }} height="auto"/>
        <IconTarget width={{
            xs: "72px",
            md: "100px",
        }} height="auto"/>
        <IconBunningsWarehouse width={{
            xs: "76px",
            md: "106px",
        }} height="auto"/>
      </Flex>
    </Flex>);
};
